export const LoaderIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      data-testid="loader-icon"
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      fill="#D7192D"
    >
      <rect x="22" width="4" height="12" rx="2" />
      <rect
        y="26"
        width="4"
        height="12"
        rx="2"
        transform="rotate(-90 0 26)"
        fillOpacity="0.8"
      />
      <rect
        x="26"
        y="48"
        width="4"
        height="12"
        rx="2"
        transform="rotate(180 26 48)"
        fillOpacity="0.6"
      />
      <rect
        x="48"
        y="22"
        width="4"
        height="12"
        rx="2"
        transform="rotate(90 48 22)"
        fillOpacity="0.4"
      />
      <rect
        x="5.61523"
        y="8.44336"
        width="4"
        height="12"
        rx="2"
        transform="rotate(-45 5.61523 8.44336)"
        fillOpacity="0.9"
      />
      <rect
        x="8.44336"
        y="42.3848"
        width="4"
        height="12"
        rx="2"
        transform="rotate(-135 8.44336 42.3848)"
        fillOpacity="0.7"
      />
      <rect
        x="42.3848"
        y="39.5566"
        width="4"
        height="12"
        rx="2"
        transform="rotate(135 42.3848 39.5566)"
        fillOpacity="0.5"
      />
      <rect
        x="39.5566"
        y="5.61523"
        width="4"
        height="12"
        rx="2"
        transform="rotate(45 39.5566 5.61523)"
        fillOpacity="0.3"
      />
    </svg>
  );
};
